import React from 'react';
import '../../www/assets/css/animation_date.css';
import methaneLegend from '../../www/assets/images/methane_legend.png';
import { left } from 'trim';
import { eventsStore,layersStore, gmapStore } from '../managers/globalState';
import { METHANE_GMAP_ID } from '../helpers/processProjects';
import { useSnapshot } from 'valtio';
import { formatDateText } from '../helpers/tools';
const animation_date = ({ date }) => {
    const { earthquakes } = layersStore.stateSnapshot;
    const { currentEvent } = useSnapshot(eventsStore.state);
    const MethaneList = ["eo_event_00000", "eo_event_009900"];
    const isMethane= MethaneList.includes(currentEvent?.id);
    const { currentGmap } = useSnapshot(gmapStore.state);
    const isMethaneGmap = currentGmap?.id === METHANE_GMAP_ID;
    const short = new Date(date);
    const shortDate=short.toISOString().split('T')[0]
    // const shortDate = formatDateText(date);

  return (
    <>
    { (isMethane || isMethaneGmap || earthquakes === true) && <div className='animation-date-div'>
        {shortDate}
      </div>}
      <div>
  { isMethane&& (<img src={methaneLegend} alt='methane legend' style={{
          position: "absolute",
          top: "64px",
          left: "1px",
          width: "190px",
          height: "197px",
         // border: "2px solid #000",
        }} />)}
      </div>
    </>
  );
};

export default animation_date;
